/** Tailwind classes for decision-role traffic light (spec hex → arbitrary values). */
export function decisionRoleBadgeClassName(code: string | null): string {
  switch (code) {
    case "AMBER":
      return "bg-[#F5A623] text-white";
    case "GREEN":
      return "bg-[#27AE60] text-white";
    case "RED":
      return "bg-[#E74C3C] text-white";
    default:
      return "bg-gray-400 text-white";
  }
}
